import { Component } from '@theme/component';

class MenuSelectComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    // Check if field-sizing is supported
    if (!this.supportsFieldSizing()) {
      // Use JavaScript fallback for browsers that don't support field-sizing
      this.initResize();
    }
  }

  /**
   * Check if the browser supports CSS field-sizing property
   * @returns {boolean}
   */
  supportsFieldSizing() {
    return CSS.supports('field-sizing', 'content');
  }

  /**
   * Handle select change event and navigate to selected URL
   * @param {Event} event
   */
  handleChange(event) {
    const target = /** @type {HTMLSelectElement} */ (event.target);
    if (!target) return;

    // Update width only if using JavaScript fallback
    if (!this.supportsFieldSizing()) {
      this.updateWidth(target);
    }

    const selectedUrl = target.value;

    if (selectedUrl && selectedUrl !== window.location.pathname) {
      target.style.opacity = '0.6';
      window.location.href = selectedUrl;
    }
  }

  /**
   * Initialize and resize the select based on selected option
   */
  initResize() {
    const selectElement = /** @type {HTMLSelectElement} */ (this.refs.select);
    if (!selectElement) return;

    this.updateWidth(selectElement);
  }

  /**
   * Update width based on select element's current value
   * @param {HTMLSelectElement} selectElement
   */
  updateWidth(selectElement) {
    const helperElement = /** @type {HTMLElement} */ (this.refs.helper);
    if (!helperElement) return;

    // Get the currently selected option text
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    if (!selectedOption) return;

    helperElement.textContent = selectedOption.textContent || '';

    const width = helperElement.offsetWidth;
    this.resize(width);
  }

  /**
   * Update the CSS custom property with the new width
   * @param {number} width - The new width in pixels
   */
  resize(width) {
    const totalWidth = width + 32;
    this.style.setProperty('--dynamic-select-width', `${totalWidth}px`);
  }
}

customElements.define('menu-select-component', MenuSelectComponent);